import { type ReactNode } from "react";
import DesktopSidebar from "./DesktopSidebar";

interface AppShellProps {
  children: ReactNode;
}

export default function AppShell({ children }: AppShellProps) {
  return (
    <div className="flex justify-center bg-background-50 min-h-full">
      <DesktopSidebar />
      <div
        className="flex-1 flex flex-col bg-white relative overflow-x-hidden
          lg:max-w-[1200px] lg:mx-auto lg:my-4 lg:rounded-2xl lg:shadow-xl lg:overflow-hidden lg:ml-[220px]"
        style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      >
        <div className="relative z-10 flex-1 flex flex-col">
          {children}
        </div>
      </div>
    </div>
  );
}
